<template>
  <v-app-bar app dark clipped-left>
    <v-toolbar-title>OLV Admin</v-toolbar-title>

    <v-spacer></v-spacer>

    <AppBarUserMenu />
  </v-app-bar>
</template>

<script>
import AppBarUserMenu from "./AppBarUserMenu";

export default {
  name: "AppBar",

  components: {
    AppBarUserMenu
  }
};
</script>

<style></style>
